var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.5H11V1.75C11 1.35218 10.842 0.970644 10.5607 0.68934C10.2794 0.408035 9.89782 0.25 9.5 0.25H6.5C6.10218 0.25 5.72064 0.408035 5.43934 0.68934C5.15804 0.970644 5 1.35218 5 1.75V2.5H2.75C2.15326 2.5 1.58097 2.73705 1.15901 3.15901C0.737053 3.58097 0.5 4.15326 0.5 4.75V11.5C0.5 12.0967 0.737053 12.669 1.15901 13.091C1.58097 13.5129 2.15326 13.75 2.75 13.75H13.25C13.8467 13.75 14.419 13.5129 14.841 13.091C15.2629 12.669 15.5 12.0967 15.5 11.5V4.75C15.5 4.15326 15.2629 3.58097 14.841 3.15901C14.419 2.73705 13.8467 2.5 13.25 2.5ZM6.5 1.75H9.5V2.5H6.5V1.75ZM14 11.5C14 11.6989 13.921 11.8897 13.7803 12.0303C13.6397 12.171 13.4489 12.25 13.25 12.25H2.75C2.55109 12.25 2.36032 12.171 2.21967 12.0303C2.07902 11.8897 2 11.6989 2 11.5V7.2925L5.51 8.5C5.58964 8.51081 5.67036 8.51081 5.75 8.5H10.25C10.3313 8.4985 10.4121 8.48588 10.49 8.4625L14 7.2925V11.5ZM14 5.71L10.13 7H5.87L2 5.71V4.75C2 4.55109 2.07902 4.36032 2.21967 4.21967C2.36032 4.07902 2.55109 4 2.75 4H13.25C13.4489 4 13.6397 4.07902 13.7803 4.21967C13.921 4.36032 14 4.55109 14 4.75V5.71Z",
    fill: "#0C2648"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.f68ada9e5c312f28015e9c1fee02950d.svg";
export { ForwardRef as ReactComponent };